import React, { useState} from "react";
import Dialog from '@mui/material/Dialog';
import { getProfilePicture } from "services/ConfigServices";
import styles from "assets/jss/material-dashboard-pro-react/components/customInputStyle.js";
import MuiDialogContent from "@mui/material/DialogContent";
import { makeStyles, withStyles } from "@mui/styles";
const useStyles = makeStyles(styles);
const infoWindowImg = {
    height: 'auto',
    maxWidth: '98%',
    marginLeft: '1%',
    verticalAlign: 'middle',
    marginBottom: '10px',
    cursor: 'pointer',
}
const dialogWindowImg = {
    height: 'auto',
    maxWidth: '98%',
    marginLeft: '1%',
    verticalAlign: 'middle',
    marginBottom: '10px'
}
const DialogContent = withStyles((theme) => ({
    root: {
      padding: '8px',
    },
  }))(MuiDialogContent);
  
export default function CustomImage(props) {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const handleOpen = (event) => { setOpen(true); };
    const handleClose = (event) => { setOpen(false); };
    const {
        width,
        imageCode,
    } = props;


    return (
        <>
            <img
                data-src="holder.js/100px180/"
                style={infoWindowImg}
                src={getProfilePicture(imageCode)}
                data-holder-rendered="true"
                alt={""}
                onClick={handleOpen}
            />
            <Dialog
                onClose={handleClose}
                aria-labelledby="edituser-dialog-title"
                fullWidth="true"
                maxWidth="lg"
                open={open}
            >
                <DialogContent>

                    <img
                        data-src="holder.js/100px180/"
                        style={dialogWindowImg}
                        src={getProfilePicture(imageCode)}
                        data-holder-rendered="true"
                        alt={""}
                        onClick={handleOpen}
                    />
                </DialogContent>
            </Dialog>
        </>
    );
}

